"use client";

import { useProductOptions } from "@repo/lib/hooks/product";
import { Media } from "@repo/ui";
import cx from "classnames";
import { Fragment } from "react";
const ProductVariants = ({
  productOptions,
  parentSlug,
  locale,
  categorySlug,
  spaceSlug
}) => {
  const {
    handleVariantSelection
  } = useProductOptions(productOptions, parentSlug, locale, categorySlug, spaceSlug);
  return <div className="mt-4" data-sentry-component="ProductVariants" data-sentry-source-file="ProductVariants.jsx">
      {productOptions?.map(option => {
      const selectedValue = option?.values?.find(value => value.selected);
      return <Fragment key={option?.name}>
            <div className="text-productDetails-subText flex text-base font-medium">
              <span className="ltr:order-2 rtl:order-1">{option?.name}:</span>
              <span className="text-productDetails-active ps-1 font-medium ltr:order-2 rtl:order-1">
                {/* Display the selected value */}
                {selectedValue?.name}
              </span>
            </div>
            <div className="flex flex-nowrap overflow-x-auto whitespace-nowrap pt-2 md:flex-wrap [&::-webkit-scrollbar]:hidden">
              {option?.values?.map(value => {
            const colorImg = value?.colorImage;
            const isSelected = Boolean(value?.selected);
            return <div key={value?.name} onClick={() => !isSelected && handleVariantSelection(option.slug, value.slug)} className={cx("border-productDetails-border mb-2 me-2 flex-shrink-0 cursor-pointer border-2", {
              "text-productDetails-subText px-4 py-1": !colorImg,
              "!border-productDetails-active !text-productDetails-active": Boolean(value?.selected),
              "bg-productDetails-bg": Boolean(value?.selected) && !colorImg
            })}>
                    {!colorImg && value?.name}
                    {colorImg && <Media src={colorImg.imageURI} width={70} height={70} alt={value?.name} />}
                  </div>;
          })}
            </div>
          </Fragment>;
    })}
    </div>;
};
export default ProductVariants;